import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TemplateDeckProposalCard({ proposal, authFetch }) {
  const navigate = useNavigate();
  const { card } = proposal;
  const topics = Array.isArray(proposal.topic_labels) ? proposal.topic_labels : [];
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [loaded, setLoaded] = useState(false);
  const url = `/api/template-deck-proposals/${card.proposal_root_id}`;
  useEffect(() => {
    let active = true;
    authFetch(url).then(async response => {
      if (!response.ok) throw new Error('The proposal could not be opened.');
      const value = await response.json();
      if (active) { setJob(value.job); setLoaded(true); }
    }).catch(failure => { if (active) setError(failure.message); });
    return () => { active = false; };
  }, [authFetch, url]);
  const open = id => navigate(`/decks/meeting-prep?templateDeck=${id}`);
  const build = async () => {
    if (busy) return;
    if (job) { open(job.deck_version_id); return; }
    setBusy(true); setError('');
    try {
      const response = await authFetch(`${url}/confirm`, { method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ approval_digest: card.approval_digest }) });
      const value = await response.json();
      if (!response.ok) throw new Error(value.detail?.message || value.detail || 'The deck could not be started.');
      setJob(value); open(value.deck_version_id);
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return <section className="cdp-card" aria-label="Proposed supplier deck">
    <h3>{card.title}</h3><p>{card.summary}</p>
    <p>{card.scope_label} · {card.length === 'quick' ? 'Quick' : 'Full'} review · up to {card.page_limit} slides</p>
    <p>{card.scope_policy}</p>
    <p>Uses this request and the conversation leading up to it.</p>
    {/* Lane 1367: the deck's topics in plain words, from the server (present
        only with WINGMAN_CHAT_DECK_SMOOTH_PATH_ENABLED). The chat line names the same words. */}
    {topics.length > 0 && <p className="cdp-topics" data-testid="cdp-topics">Covers: {topics.join(', ')}</p>}
    {error && <p role="alert">{error}</p>}
    <button className="cdp-primary" type="button" disabled={!loaded || busy} onClick={build}>{busy ? 'Starting…' : job ? 'Open deck' : 'Build deck'}</button>
  </section>;
}
